import React from 'react'
import {get} from 'lodash'
import Link from 'next/link'
import dynamic from 'next/dynamic'

import {t, axios} from '@lib/helpers'

const Meta = dynamic(() => import('@components/Meta'))
const Custom404 = dynamic(() => import('@components/Custom404'))

const ServicesShow = ({service, query}) => {
  if (get(service, '_status')) {
    return <Custom404 />
  }

  return (
    <React.Fragment>
      <Meta
        title={
          get(service, 'meta_title') ||
          `${t('pages.services.title')} – ${get(service, 'title')} – ${t(
            'layout.title'
          )}`
        }
        description={get(service, 'meta_description')}
      />

      <div className='ServicesShow'>
        <div className='ServicesShow__hero'>
          <div className='ServicesShow__hero__wrapper-outer'>
            <div className='container'>
              <img
                className='ServicesShow__hero__img'
                alt='ServicesShow__hero__img'
                src='/images/ServicesShow__hero__img--0.jpg'
              />

              <div className='ServicesShow__hero__wrapper'>
                <h1 className='ServicesShow__hero__h2'>
                  {get(service, 'title')}
                </h1>

                {get(service, 'subtitle') && (
                  <p className='ServicesShow__hero__p'>
                    {get(service, 'subtitle')}
                  </p>
                )}

                <Link href='#contact-form'>
                  <a className='ServicesShow__hero__contact Buttons Button'>
                    {t('pages.servicesShow.contact_us')}
                  </a>
                </Link>

                <div className='Buttons'>
                  <Link href='/services'>
                    <a className='ServicesShow__hero__a'>
                      {t('pages.servicesShow.back')}
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='BodySpace BodySpace--no-top BodySpace--no-bottom'>
          <div className='ServicesShow__dual'>
            <div className='ServicesShow__dual__wrapper'>
              <div className='container'>
                {[
                  {
                    h3: 'Problem',
                    ps: get(service, 'problem'),
                  },
                  {
                    h3: 'Solution',
                    ps: get(service, 'solution'),
                  },
                ].map((x, i) => (
                  <div className='ServicesShow__dual__box' key={i}>
                    <h3 className='ServicesShow__dual__box__h3'>
                      {get(x, 'h3')}
                    </h3>

                    <div
                      className='ServicesShow__dual__box__p'
                      dangerouslySetInnerHTML={{__html: get(x, 'ps')}}
                    ></div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className='ServicesShow__deliverables'>
            <div className='container'>
              <h3 className='ServicesShow__deliverables__h3'>
                {t('pages.servicesShow.deliverables')}
              </h3>

              <div
                className='ServicesShow__deliverables__dl'
                dangerouslySetInnerHTML={{__html: get(service, 'deliverables')}}
              ></div>
            </div>
          </div>

          <div className='ServicesShow__end-result'>
            <div className='container'>
              <div className='ServicesShow__end-result__box'>
                <h3 className='ServicesShow__end-result__box__h3'>
                  {t('pages.servicesShow.end_result')}
                </h3>

                <div
                  className='ServicesShow__end-result__box__p'
                  dangerouslySetInnerHTML={{
                    __html: get(service, 'expected_end_result'),
                  }}
                ></div>
              </div>

              <div className='ServicesShow__end-result__footer'>
                <h4 className='ServicesShow__end-result__footer__h4'>
                  {t('pages.servicesShow.similar')}
                </h4>

                <div className='ServicesShow__end-result__footer__links'>
                  {(get(service, 'similar') || []).map((x, i) => (
                    <Link
                      href='/services/[id]'
                      as={`/services/${get(x, 'slug')}`}
                      key={i}
                    >
                      <a
                        key={i}
                        className='ServicesShow__end-result__footer__links__a'
                      >
                        <span className='ServicesShow__end-result__footer__links__a__span'>
                          {get(x, 'title')}
                        </span>
                      </a>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

ServicesShow.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let service

  try {
    service = await axios.get(`/services/${get(ctx, 'query.id')}`)
  } catch (e) {
    const _status = get(e, 'response.status')

    if (ctx.res) {
      ctx.res.statusCode = _status
    }

    return {
      props: {
        service: {
          _status,
        },
      },
    }
  }

  return {
    props: {
      service: get(service, 'data.data'),
      query: get(ctx, 'query'),
    },
  }
}

export default ServicesShow
